import type { ReactNode } from 'react'

/**
 * Tabelle und die drei Zustände drumherum.
 *
 * **Kein Kasten um die Tabelle:** In der Vorlage steht sie frei auf der weißen
 * Karte, getrennt nur durch Linien. Ein Rahmen darum ergäbe eine Karte in
 * einer Karte.
 *
 * Herausgezogen aus `Kunde.tsx`, weil die Kontenverwaltung dieselbe Tabelle
 * braucht. Zwei Kopien liefen beim nächsten Maß auseinander, und dann steht
 * auf zwei Seiten dasselbe verschieden da.
 */
export function Tabelle({ kopf, children }: { kopf: string[]; children: ReactNode }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[34rem] text-left text-[13.5px]">
        <thead>
          <tr>
            {kopf.map((titel) => (
              <th
                key={titel}
                className="border-b border-secondary pr-2.5 pb-2 text-[11.5px] font-medium text-quaternary"
              >
                {titel}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}

export function Laedt({ children }: { children: ReactNode }) {
  return (
    <p role="status" className="py-6 text-sm text-tertiary">
      {children}
    </p>
  )
}

export function Fehler({ children }: { children: ReactNode }) {
  return (
    <p role="status" className="rounded-xl bg-error-primary p-4 text-sm text-error-primary">
      {children}
    </p>
  )
}

export function Leer({ titel, children }: { titel: string; children: ReactNode }) {
  return (
    <div className="rounded-xl border border-dashed border-secondary p-8 text-center">
      <p className="font-medium text-primary">{titel}</p>
      <p className="mt-1 text-sm text-tertiary">{children}</p>
    </div>
  )
}
